'use client';

import { useFiltersContext } from '@components/FilterPage/Context/useFiltersContext';
import { IconButton, Input, InputAdornment, SxProps } from '@coolblue-development/freddy';
import searchInteractionTrigger from '@coolblue-development/ga4-events/triggers/RecruitmentInteraction/searchInteractionTrigger';
import { Magnifier } from '@coolblue-development/icons';
import { useAnalytics } from '@coolblue-development/next-analytics/client';
import { useTranslation } from '@i18n/useTranslation';
import React, { useEffect, useState } from 'react';

type Props = {
  sx?: SxProps;
};

export const SearchInput = ({ sx }: Props) => {
  const { trackEvent } = useAnalytics();
  const { setQuery, getSearchQuery } = useFiltersContext();
  const searchQuery = getSearchQuery();
  const { t } = useTranslation('filterPage.filterFacets');

  const [searchValue, setSearchValue] = useState(searchQuery);

  useEffect(() => {
    // We need it when we clear all filters, including the search query, to reset the input value
    setSearchValue(searchQuery);
  }, [searchQuery]);

  const handleSearch = (method: 'enter' | 'click') => {
    trackEvent(searchInteractionTrigger({ search_term: searchValue, method }));
    setQuery(searchValue);
  };
  return (
    <Input
      type='search'
      name='search'
      value={searchValue}
      onChange={e => {
        const value = e.currentTarget.value;
        setSearchValue(value);
        if (!value) setQuery('');
      }}
      onKeyDown={e => e.key === 'Enter' && handleSearch('enter')}
      endAdornment={
        <InputAdornment>
          <IconButton onClick={() => handleSearch('click')} aria-label='Search'>
            <Magnifier />
          </IconButton>
        </InputAdornment>
      }
      placeholder={t('searchPlaceholder')}
      sx={sx}
    />
  );
};
